import React from 'react';
import * as Styles from './DisclaimerExternalDomain.styles';
import {
  Button,
  IconAtencion,
  IconLoading,
} from 'gatorcomponents';
import PropTypes from 'prop-types';
import { useResize } from '@/hooks/useResize';

export const DisclaimerExternalDomain = ({
  title,
  subtitle,
  onClickCta,
  cta,
  loading,
}) => {
  const { width } = useResize();
  const isMobile = width <= 600;

  const handleCta = () => {
    onClickCta && onClickCta();
  };

  return (
    <Styles.Wrapper data-testid="DisclaimerExternalDomain">
      <Styles.Title data-testid="title">
        <IconAtencion size={isMobile ? 'lg' : 'xl'} />
        {title}
      </Styles.Title>

      <Styles.Subtitle data-testid="subtitle">
        {subtitle}
      </Styles.Subtitle>

      <Styles.ButtonsWrapper>
        <Button
          testId="cta"
          size="large"
          onClick={handleCta}
          disabled={loading}
          label={loading ? <IconLoading /> : cta}
        />
      </Styles.ButtonsWrapper>
    </Styles.Wrapper>
  );
};
DisclaimerExternalDomain.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  onClickCta: PropTypes.func.isRequired,
  cta: PropTypes.string.isRequired,
  loading: PropTypes.bool,
};

export default DisclaimerExternalDomain;
